import { render, staticRenderFns } from "./ForgeViewerWidget.vue?vue&type=template&id=3f84b942&scoped=true&"
import script from "./ForgeViewerWidget.vue?vue&type=script&lang=js&"
export * from "./ForgeViewerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84b942",
  null
  
)

export default component.exports